module.exports = __webpack_public_path__ + "static/media/matilde-cap-china-sleepy.8ad1fcc6.png";